<mat-form-field #formFieldContainer floatLabel="always" class="slider-class">
  <mat-label
    #labelContainer  (click)="toggleTooltip(tooltip)"
    class="{{componentDefinition?.mandatory ? 'mandatory' : ''}} ">{{sliderLabel}}</mat-label>
  <div class="labelToolTipContainer"
    #tooltip="matTooltip"
    matTooltip="{{componentDefinition.label}}"
    [matTooltipDisabled]="showToolTip(tooltip,formFieldContainer,labelContainer)">
  </div>
  <input matInput hidden>
  <mat-slider thumbLabel
              [min]="min"
              [max]="max"
              [step]="step"
              (change)="onValueChanged($event.value)"
              [formControl]="formControl"
              (input)="onSliderInputChange($event)"
  >
  </mat-slider>
</mat-form-field>
<ft-validation-display [model]="document" [componentDefinition]="componentDefinition"></ft-validation-display>
